import Button from 'lib/ui/Button'
import React from 'react'
import RefreshIcon from '@material-ui/icons/Cached'
import ConfirmDialog from 'lib/ui/ConfirmDialog'
import {useRegenerateWidgetToken} from 'lib/event-api/widgets/use-regenerate-widget-token'
import styled from 'styled-components'
import {spacing} from 'lib/ui/theme'

export function RegenerateTokenButton() {
  const {mutate, isLoading} = useRegenerateWidgetToken()

  return (
    <>
      <ConfirmDialog
        description={
          <>
            This will generate a new event-scoped token and{' '}
            <b>immediately invalidate all previous widgets</b>.
            <br />
            <br />
            Any existing widgets on client sites will stop working until they
            update to the new code.
            <br />
            <br />
            Use this if a code was shared, leaked, or for routine security
            rotation.
          </>
        }
        onConfirm={() => mutate()}
        confirmLabel="Regenerate Tokens"
        variant="dangerous"
      >
        {(confirm) => (
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={confirm}
            disabled={isLoading}
            aria-label="regenerate tokens"
            type="button"
          >
            <RefreshIcon style={{marginRight: 5}} /> Regenerate tokens
          </StyledButton>
        )}
      </ConfirmDialog>
    </>
  )
}

const StyledButton = styled(Button)`
  margin-right: ${spacing[4]};
  padding: ${spacing[1]};
`
